import React, { useEffect, useRef, useState, useCallback, useContext, useMemo, Fragment } from 'react';
import { Row, Col, Button, ButtonToolbar, Spinner, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { getProjectResumeInvoices, getModalData, getTenderProcedures, getTenderClassifications, getTenderCriteria } from '@lib/api';
import { AgGridReact } from 'ag-grid-react/lib/agGridReact';
import '@ag-grid-community/core/dist/styles/ag-grid.css';
import '@ag-grid-community/core/dist/styles/ag-theme-alpine.css';
import AG_GRID_LOCALE_IT from '@components/ag-grid/locale-it';
import { columnCentered } from '@lib/helpers/agGridHelpers';
import { formatToDecimals } from '@lib/helpers/formatting';
import CustomPaginationMui from '@components/materialComponents/CustomPaginationMui';
import { /*IcoRefresh,*/ ExclamationBrown, RejectSolid, ConfirmSolid, CircleGrey, BlackPause } from '@icons';
// import OEFilterExternalSupplies from 'components/oefilter/OEFilterExternalSupplies';
import TendersSummaryModal from 'components/summary/TendersSummaryModal';
import FrameworkContractDetailModal from 'components/summary/FrameworkContractDetailModal';
import ProjectContractModal from 'components/contracts/projectContractModal';
import ProjectInvoiceModal from 'components/invoice/projectInvoiceModal';
import ProjectPaymentModal from 'components/payments/projectPaymentModal';
import ProjectTimesheetModal from 'components/timesheet/projectTimesheetModal';
// import CustomQuickFilterBox from 'components/ag-grid/CustomQuickFilterBox';
import OwnershipCellRenderer from '../OwnershipCellRenderer';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Loading } from '@components/atomic/atoms';
import { UserContext } from '@components/contexts/UserProvider';
import { getUsersByProjectId } from '@lib/api_ts/usersApi';
import { /*useHistory,*/ useLocation, useParams } from 'react-router-dom';
import CustomFilter from './CustomFilter/CustomFilter';
import { parseQueryParams, wrapQueryParams } from '@components/project/Sampling/CustomFilter/queryParamsUtils';
import FiltersToDisplay from './CustomFilter/FiltersToDisplay';
import CustomSearch from './CustomFilter/CustomSearch';

const ExternalSupplies = ({
	project,
	activeKey,
	isActiveSampling,
	// isDoneSamplingWithCompleteList,
	externalSupplies,
	setExternalSupplies,
	externalSuppliesMeta,
	setExternalSuppliesMeta,
	sampling,
	setFilterQueryParamsString,
}) => {
	const [columnDefsExternalSupplies, setColumnDefsExternalSupplies] = useState([]);
	// const [isFirstResearch1, setIsFirstResearch1] = useState(true);
	const externalSuppliesRef = useRef(null);
	const [apiToCall, setApiToCall] = useState('');
	const [modalData, setModalData] = useState({});
	const [optionsProcedures, setOptionsProcedures] = useState([]);
	const [optionsClassifications, setOptionsClassifications] = useState([]);
	const [optionsCriteria, setOptionsCriteria] = useState([]);
	const [optionsDedicated, setOptionsDedicated] = useState([]);
	const [optionsGazettePubIT, setOptionsGazettePubIT] = useState([]);
	const [optionsGazettePubUE, setOptionsGazettePubUE] = useState([]);
	const [show, setShow] = useState(false);
	const [refresh, setRefresh] = useState(false);
	const localeText = AG_GRID_LOCALE_IT;
	const [openRowId, setOpenRowId] = useState(null);

	const [isSampled, setIsSampled] = useState(false);

	// const history = useHistory();
	const { search /*, pathname*/ } = useLocation();
	const isCompleteList = search.includes('complete-list=true');
	// const isFiltered = search.includes('filter=true');
	const initialQueryParams = isActiveSampling && !isCompleteList ? `?sampling=1` : undefined;
	const queryClient = useQueryClient();
	//console.log('isDoneSampling', isDoneSampling);
	//console.log('isCompleteList', isCompleteList);

	const [queryParams, setQueryParams] = useState(initialQueryParams);
	const [activeFilters, setActiveFilters] = useState(initialQueryParams ? parseQueryParams(initialQueryParams) : {});

	// console.log('activeFilters', activeFilters);

	const searchRef = useRef(null);

	useEffect(() => {
		setActiveFilters(queryParams ? parseQueryParams(queryParams) : {});
		setFilterQueryParamsString(queryParams);
	}, [queryParams, setFilterQueryParamsString]);

	const handleAssignedToMe = (event) => {
		const isChecked = event.target.checked;

		setActiveFilters((prevFilters) => {
			let newFilters;

			if (isChecked) {
				newFilters = {
					...prevFilters,
					assigned: [...(prevFilters.assigned || []), String(myUserId)],
				};
			} else {
				const updated = prevFilters.assigned?.filter((id) => id !== String(myUserId)) || [];

				if (updated.length === 0) {
					const { assigned, ...rest } = prevFilters;
					newFilters = rest;
				} else {
					newFilters = { ...prevFilters, assigned: updated };
				}
			}

			setQueryParams(wrapQueryParams(newFilters));

			// if (
			// 	Object.keys(newFilters).filter((activeFilter) => activeFilter !== 'sampling').length === 0 ||
			// 	Object.values(newFilters).every((values) => values.length === 0)
			// ) {
			// 	history.push(`${pathname}${search.replace('filter=true', '').replace('&', '')}`);
			// } else {
			// 	history.push(`${pathname}${isCompleteList ? (search.includes('filter=true') ? search : search + '&filter=true') : '?filter=true'}`);
			// }

			return newFilters;
		});
	};

	const { projectId } = useParams();

	const { data: users, isPending: isPendingUsers } = useQuery({
		queryKey: ['usersPerProject', projectId],
		queryFn: () => getUsersByProjectId(projectId),
		enabled: !!projectId,
	});

	const {
		myUser, //: { id: myUserId },
	} = useContext(UserContext);
	const myUserId = !isPendingUsers ? users.find((user) => user.email === myUser.email)?.id : undefined;

	const defaultColDef = {
		resizable: true,
		flex: 1,
		wrapText: true,
		autoHeight: true,
		suppressMovable: true,
		cellStyle: {
			paddingLeft: '1rem',
			paddingRight: '1rem',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			color: '#1C2743',
			display: 'flex',
			alignItems: 'center',
			height: '100%',
		},
		headerClass: 'text-center',
		suppressKeyboardEvent: () => {
			// Prevent keyboard events in the grid
			return true;
		},
		suppressSizeToFit: true,
	};

	const {
		data: resumeInvoicesRes,
		refetch: refetchResumeInvoices,
		isPending: isPendingResumeInvoices,
	} = useQuery({
		queryKey: ['resumeInvoices', project.id, 'externalSupplies', queryParams, isCompleteList],
		queryFn: () => {
			const cleanedQueryParams = new URLSearchParams(queryParams);
			if (isCompleteList) cleanedQueryParams.delete('sampling');
			const queryString = cleanedQueryParams ? `?${cleanedQueryParams.toString()}` : '';
			return getProjectResumeInvoices(project.id, queryString, 'externalSupplies');
		},
		enabled: !!project.id && activeKey === 'external-supplies',
	});

	useEffect(() => {
		if (!resumeInvoicesRes) return;
		if (resumeInvoicesRes.success) {
			setExternalSupplies(resumeInvoicesRes.data);
			const { data, success, ...restResp } = resumeInvoicesRes;
			setExternalSuppliesMeta(restResp);
		} else {
			console.error('Failed to fetch resume invoices:', resumeInvoicesRes);
		}
	}, [resumeInvoicesRes, setExternalSupplies, setExternalSuppliesMeta]);

	const modalDataMutation = useMutation({
		mutationFn: (url) => getModalData(url),
		onSuccess: (response) => {
			setModalData(response.data);
		},
		onError: (error) => {
			console.error('Error fetching modal data:', error);
		},
	});
	// N.D.R. we need useMemo here to have a stable reference for the mutate function,
	// because we need to include it in the cellRenderer useCallback dependencies
	const modalDataMutationMutateMemo = useMemo(() => modalDataMutation.mutate, [modalDataMutation.mutate]);

	useEffect(() => {
		if (refresh) {
			refetchResumeInvoices();

			if (sampling.id) {
				queryClient.invalidateQueries({ queryKey: ['samplingStatistics', project.id, sampling.id] });
			}

			setRefresh(false);
		}
	}, [refresh, refetchResumeInvoices, project.id, queryClient, sampling.id]);

	useEffect(() => {
		const optionsYesNo = [
			{
				value: true,
				label: 'SÌ',
			},
			{
				value: false,
				label: 'NO',
			},
		];

		getTenderProcedures().then((retrievedProcedures) => {
			setOptionsProcedures(
				retrievedProcedures.data.map((procedure) => ({
					value: procedure.code,
					label: procedure.name,
				})),
			);
		});

		getTenderClassifications().then((retrievedClassification) => {
			setOptionsClassifications(
				retrievedClassification.data.map((classification) => ({
					value: classification.code,
					label: classification.name,
				})),
			);
		});

		getTenderCriteria().then((retrievedCriteria) => {
			setOptionsCriteria(
				retrievedCriteria.data.map((criteria) => ({
					value: criteria.code,
					label: criteria.name,
				})),
			);
		});

		setOptionsGazettePubIT(optionsYesNo);
		setOptionsDedicated(optionsYesNo);
		setOptionsGazettePubUE(optionsYesNo);
	}, []);

	const ResumeChecklistCellRenderer = useCallback(
		(params) => {
			if (params.value && params?.value.keyValue) {
				//console.log('CL color:', params.value?.checkliststatus?.color);
				let message = '';
				let icon = null;

				if (params.value.checkliststatus) {
					let checklistColor = params.value.checkliststatus.color;
					let isGARA = false;

					if (
						params?.queryParam === 'tender_number' &&
						(params.value.key.keyValue?.startsWith('GARATEMP_') || params.value.key.keyValue?.startsWith('GARA_'))
					) {
						isGARA = true;
						checklistColor = params.value.key.keyValue?.startsWith('GARATEMP_')
							? 'yellow'
							: params.value.key.keyValue?.startsWith('GARA_')
								? 'grey'
								: params.value?.checkliststatus?.color;
					}

					switch (checklistColor) {
						case 'green':
							icon = <ConfirmSolid width="1.3em" height="1.3em" />;
							message = 'Conforme';
							break;
						case 'green_white':
							icon = <ConfirmSolid width="1.3em" height="1.3em" />;
							message = 'Conforme - da validare';
							break;
						case 'green_white_settled':
							icon = <ConfirmSolid width="1.3em" height="1.3em" />;
							message = 'Conforme - validato';
							break;
						case 'yellow':
							icon = <RejectSolid width="1.3em" height="1.3em" />;
							message = isGARA ? 'Non ancora disponibile' : 'Incompleta';
							break;
						case 'red':
							icon = <RejectSolid width="1.3em" height="1.3em" />;
							message = 'Non conforme';
							break;
						case 'grey':
						case 'gray':
							icon = <BlackPause width="1.3em" height="1.3em" />;
							message = isGARA ? 'Non applicabile' : 'In lavorazione';
							break;
						case 'white':
							icon = null;
							break;
						default:
							break;
					}
				}

				let value;

				if (params.value.key === 'tender_number' && params.value.keyValue.startsWith('GARA_')) {
					value = 'N.A.';
				} else if (params.value.key === 'tender_number' && params.value.keyValue.startsWith('GARATEMP_')) {
					value = 'N.D.';
				} else {
					value = params.value.keyValue;
				}

				const canBeLink = () => {
					if (project.streamConfigurationType === 'STREAM') {
						return true;
					}

					return false;
				};

				const ConditionalWrapper = ({ condition, wrapper, children }) => (condition ? wrapper(children) : children);

				return (
					<>
						<Row className="align-items-center justify-content-between h-100 flex-nowrap">
							{isActiveSampling && !isCompleteList ? (
								<>
									<Col xs="auto" className="pe-1">
										{icon ? (
											<>
												<OverlayTrigger placement="top" overlay={<Tooltip>{message}</Tooltip>}>
													{icon}
												</OverlayTrigger>
											</>
										) : null}
									</Col>
								</>
							) : null}
							<Col className={isActiveSampling && !isCompleteList ? 'overflow-hidden ps-0' : ''}>
								<ConditionalWrapper
									condition={params.link && !params.value.keyValue.startsWith('GARA_' || 'GARATEMP_') && canBeLink()}
									wrapper={(children) => (
										<Button
											variant="link"
											className="d-flex align-items-start projectModalRenderBtn"
											style={{ color: '#1C2743' }}
											onClick={() => {
												setApiToCall(params.value.key);
												// fetchData(params.value.href.url);
												// modalDataMutation.mutate(params.value.href.url);
												modalDataMutationMutateMemo(params.value.href.url);
												params.setShow(true);
												setIsSampled(params.data.sampled);
											}}
										>
											{children}
										</Button>
									)}
								>
									<span>
										{Object.values(params.data).find((value) => value.key === params.value.key)?.hasDocuments === false ? (
											<OverlayTrigger placement="top" overlay={<Tooltip>Documento mancante</Tooltip>}>
												<ExclamationBrown fill="#995C00" className="me-2" />
											</OverlayTrigger>
										) : null}
										{params.value.keyValue ? (
											typeof params.value.keyValue === 'number' ? (
												formatToDecimals(params.data.taxableAmount) + ' €'
											) : (
												value
											)
										) : (
											<>&zwnj;</>
										)}
									</span>
								</ConditionalWrapper>
							</Col>
						</Row>
					</>
				);
			}
		},
		[isActiveSampling, project.streamConfigurationType, modalDataMutationMutateMemo, isCompleteList],
	);

	const TotalResumeChecklistCellRenderer = useCallback((params) => {
		// params.value = reportable
		// VERDE conforme -> tutti verdi (anche green_white e green_white_settled) (nessuna risposta N.D. o NO) BASTA IL FLAG
		// ROSSO non conforme -> sia rossi che gialli (almeno una risposta N.D. o NO) BASTA IL FLAG

		let icon;
		let firstMessage = '';
		let secondMessage = '';
		const arrayEntities = ['tender', 'frameworkContract', 'contract', 'invoice', 'payment'];

		if (params.value && params.data) {
			icon = <ConfirmSolid width="1.3em" height="1.3em" />;
			firstMessage = 'conforme';

			const hasSomeGreenWhiteChecklist = arrayEntities.every(
				(entity) => params.data[entity].checkliststatus && params.data[entity]?.checkliststatus.color === 'green_white',
			);

			firstMessage += hasSomeGreenWhiteChecklist ? ' - da validare' : '';
			secondMessage = 'visibile in rendicontazione';
		} else {
			const hasAllWhiteChecklist = arrayEntities.every(
				(entity) => params.data[entity]?.checkliststatus && params.data[entity]?.checkliststatus.color === 'white',
			);

			const hasSomeWhiteChecklist = arrayEntities.some(
				(entity) => params.data[entity]?.checkliststatus && params.data[entity]?.checkliststatus.color === 'white',
			);

			if (hasAllWhiteChecklist) {
				icon = <CircleGrey width="1.3em" height="1.3em" />;
				firstMessage = 'da controllare';
				secondMessage = 'inizia le azioni di controllo';
			} else if (hasSomeWhiteChecklist) {
				icon = <BlackPause width="1.3em" height="1.3em" />;
				firstMessage = 'da completare';
				secondMessage = 'controlla tutti gli elementi';
			} else {
				icon = <RejectSolid width="1.3em" height="1.3em" />;
				firstMessage = 'non conforme';
				secondMessage = 'non visibile in rendicontazione';
			}
		}

		return (
			<Row className="align-items-center justify-content-center h-100">
				<Col className="col-auto text-center">{icon}</Col>
				<Col>
					<span className="f-700 d-block">{firstMessage}</span>
					<span>{secondMessage}</span>
				</Col>
			</Row>
		);
	}, []);

	useEffect(() => {
		setColumnDefsExternalSupplies([
			{
				headerName: 'Procedura',
				field: 'tender',
				cellRenderer: ResumeChecklistCellRenderer,
				cellRendererParams: {
					link: true,
					setShow: setShow,
					setApiToCall: setApiToCall,
					queryParam: 'tender_number',
				},
				//minWidth: 250,
				filter: 'agTextColumnFilter',
				filterValueGetter: (params) => {
					let value;

					if (params.data.tender.keyValue.startsWith('GARA_')) {
						value = 'N.A.';
					} else if (params.data.tender.keyValue.startsWith('GARATEMP_')) {
						value = 'N.D.';
					} else {
						value = params.data.tender.keyValue;
					}

					return value;
				},
				comparator: (valueA, valueB) => {
					let tempValueA = valueA.keyValue.startsWith('GARA_')
						? 'N.A.'
						: valueA.keyValue.startsWith('GARATEMP_')
							? 'N.D.'
							: valueA.keyValue;
					let tempValueB = valueB.keyValue.startsWith('GARA_')
						? 'N.A.'
						: valueB.keyValue.startsWith('GARATEMP_')
							? 'N.D.'
							: valueB.keyValue;

					if (tempValueA === tempValueB) return 0;
					return tempValueA > tempValueB ? 1 : -1;
				},
			},
			{
				headerName: 'Contratto aperto',
				field: 'frameworkContract',
				cellRenderer: ResumeChecklistCellRenderer,
				cellRendererParams: {
					link: true,
					setShow: setShow,
					setApiToCall: setApiToCall,
					queryParam: 'framework_contract_number',
				},
				//minWidth: 230,
				filter: 'agTextColumnFilter',
				filterValueGetter: (params) => {
					return params.data.frameworkContract.keyValue;
				},
				comparator: (valueA, valueB) => {
					if (valueA.keyValue === valueB.keyValue) return 0;
					return valueA.keyValue > valueB.keyValue ? 1 : -1;
				},
			},
			{
				headerName: 'Incarico/attingimento',
				field: 'contract',
				cellRenderer: ResumeChecklistCellRenderer,
				cellRendererParams: {
					link: true,
					setShow: setShow,
					setApiToCall: setApiToCall,
					queryParam: 'contract_number',
				},
				//minWidth: 240,
				filter: 'agTextColumnFilter',
				filterValueGetter: (params) => {
					return params.data.contract.keyValue;
				},
				comparator: (valueA, valueB) => {
					if (valueA.keyValue === valueB.keyValue) return 0;
					return valueA.keyValue > valueB.keyValue ? 1 : -1;
				},
			},
			{
				headerName: 'Fattura',
				field: 'invoice',
				cellRenderer: ResumeChecklistCellRenderer,
				cellRendererParams: {
					link: true,
					setShow: setShow,
					setApiToCall: setApiToCall,
					queryParam: 'rp_code',
				},
				//minWidth: 230,
				filter: 'agTextColumnFilter',
				filterValueGetter: (params) => {
					return params.data.invoice.keyValue;
				},
				comparator: (valueA, valueB) => {
					if (valueA.keyValue === valueB.keyValue) return 0;
					return valueA.keyValue > valueB.keyValue ? 1 : -1;
				},
			},
			{
				headerName: 'Pagamento',
				field: 'payment',
				cellRenderer: ResumeChecklistCellRenderer,
				cellRendererParams: {
					link: true,
					setShow: setShow,
					setApiToCall: setApiToCall,
					queryParam: 'payment_number',
				},
				//minWidth: 230,
				filter: 'agTextColumnFilter',
				filterValueGetter: (params) => {
					return params.data.payment.keyValue;
				},
				comparator: (valueA, valueB) => {
					if (valueA.keyValue === valueB.keyValue) return 0;
					return valueA.keyValue > valueB.keyValue ? 1 : -1;
				},
			},
			{
				headerName: 'Ownership',
				field: 'ownership',
				minWidth: 295,
				filter: 'agTextColumnFilter',
				// TODO: sistema col find sugli users
				// filterValueGetter: (params) => {
				// 	return params.data.ownership.keyValue;
				// },
				cellRendererParams: {
					queryParam: 'assigned',
				},
				comparator: (valueA, valueB) => {
					if (valueA.keyValue === valueB.keyValue) return 0;
					return valueA.keyValue > valueB.keyValue ? 1 : -1;
				},
				cellRenderer: (params) => {
					return <OwnershipCellRenderer {...params} />;
				},
				...columnCentered(),
				cellStyle: {
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					// overflow: 'visible',
					textOverflow: 'ellipsis',
					overflow: 'hidden',
					whiteSpace: 'nowrap',
				},
				cellClass: 'cell-dropdown',
			},
			{
				headerName: 'Stato del controllo',
				field: 'reportable',
				cellRenderer: (params) => {
					if (!isActiveSampling || (isActiveSampling && !isCompleteList)) {
						return <TotalResumeChecklistCellRenderer {...params} />;
					} else if (isActiveSampling && isCompleteList) {
						if (params.data.sampled) {
							return (
								<>
									<span>campionato</span>
								</>
							);
						} else {
							return (
								<>
									<Row className="justify-content-center align-items-center">
										<Col className="col-auto pe-0 mb-1">
											<ExclamationBrown fill="#995C00" className="align-bottom me-2" />
										</Col>
										<Col className="col-auto ps-0">
											<span>esegui prima il campionamento</span>
										</Col>
									</Row>
								</>
							);
						}
					}

					/* if (isActiveSampling && isCompleteList) {
						if (params.data.sampled) {
							return (
								<>
									<span>campionato</span>
								</>
							);
						} else {
							return (
								<>
									<Row className="justify-content-center align-items-center">
										<Col className="col-auto pe-0 mb-1">
											<ExclamationBrown fill="#995C00" className="align-bottom me-2" />
										</Col>
										<Col className="col-auto ps-0">
											<span>esegui prima il campionamento</span>
										</Col>
									</Row>
								</>
							);
						}
					} else {
						return <TotalResumeChecklistCellRenderer {...params} />;
					} */
				},
				cellRendererParams: {
					queryParam: 'reportable',
				},
				minWidth: 180,
				...columnCentered(),
				cellStyle: {
					whiteSpace: 'initial',
					justifyContent: 'center',
				},
			},
		]);
	}, [ResumeChecklistCellRenderer, TotalResumeChecklistCellRenderer, isCompleteList, isActiveSampling]);

	const renderCorrectModal = (modalToRender) => {
		switch (modalToRender) {
			case 'tender_number':
				return (
					<TendersSummaryModal
						isSampled={isSampled}
						data={modalData}
						optionsProcedures={optionsProcedures}
						optionsClassifications={optionsClassifications}
						optionsCriteria={optionsCriteria}
						optionsGazettePubIT={optionsGazettePubIT}
						optionsGazettePubUE={optionsGazettePubUE}
						optionsDedicated={optionsDedicated}
						modalIsVisible={show}
						setModalIsVisible={setShow}
						spinnerVisible={modalDataMutation.isPending}
						setModalData={setModalData}
						isSummary
						setRefresh={setRefresh}
					/>
				);
			case 'framework_contract_number':
				return (
					<FrameworkContractDetailModal
						isSampled={isSampled}
						data={modalData}
						setModalIsVisible={setShow}
						modalIsVisible={show}
						spinnerVisible={modalDataMutation.isPending}
						setModalData={setModalData}
						isSummary
						setRefresh={setRefresh}
					/>
				);
			case 'contract_number':
				return (
					<ProjectContractModal
						isSampled={isSampled}
						data={modalData}
						setModalIsVisible={setShow}
						modalIsVisible={show}
						isSummary
						spinnerVisible={modalDataMutation.isPending}
						setModalData={setModalData}
						setRefresh={setRefresh}
						projectStreamConfigurationType={project.streamConfigurationType}
					/>
				);
			case 'rp_code':
				return (
					<ProjectInvoiceModal
						isSampled={isSampled}
						data={modalData}
						setModalIsVisible={setShow}
						modalIsVisible={show}
						isSummary
						spinnerVisible={modalDataMutation.isPending}
						setModalData={setModalData}
						setRefresh={setRefresh}
						projectStreamConfigurationType={project.streamConfigurationType}
						projectAdvancedConfig={project.advancedConfig}
					/>
				);
			case 'payment_number':
				return (
					<ProjectPaymentModal
						data={modalData}
						setModalIsVisible={setShow}
						modalIsVisible={show}
						isSummary
						spinnerVisible={modalDataMutation.isPending}
						setModalData={setModalData}
						setRefresh={setRefresh}
					/>
				);
			case 'number':
				return (
					<ProjectTimesheetModal
						data={modalData}
						setModalIsVisible={setShow}
						modalIsVisible={show}
						isSummary
						spinnerVisible={modalDataMutation.isPending}
						setModalData={setModalData}
						setRefresh={setRefresh}
						isProjectSco={project.sco}
					/>
				);
			default:
		}
	};

	// const RefreshButton = () => {
	// 	return (
	// 		<OverlayTrigger placement="top" overlay={<Tooltip>Refresh</Tooltip>}>
	// 			<Button
	// 				onClick={() => {
	// 					refetchResumeInvoices();
	// 				}}
	// 				variant="link"
	// 				className="me-2"
	// 				style={{ padding: '0.2rem', height: '2.235rem', width: '2.211rem' }}
	// 			>
	// 				{isPendingResumeInvoices ? (
	// 					<Spinner
	// 						as="span"
	// 						className="mx-1"
	// 						animation="border"
	// 						size="sm"
	// 						role="status"
	// 						aria-hidden="true"
	// 						style={{ verticalAlign: 'middle' }}
	// 					/>
	// 				) : (
	// 					<IcoRefresh className="ico-path-fill-primary m-0" />
	// 				)}
	// 			</Button>
	// 		</OverlayTrigger>
	// 	);
	// };

	useEffect(() => {
		// let timer = null;
		if (
			isPendingResumeInvoices
			// || isFetchingResumeInvoices
		) {
			// timer =
			setTimeout(() => {
				externalSuppliesRef.current?.api?.showLoadingOverlay();
			}, 100);
		} else {
			externalSuppliesRef.current?.api?.hideOverlay();
		}
		// return () => clearTimeout(timer);
	}, [
		isPendingResumeInvoices,
		// , isFetchingResumeInvoices
	]);

	const getMessageByStoplightColor = (color) => {
		switch (color) {
			case 'white':
				return 'Da lavorare';
			case 'grey':
			case 'gray':
				return 'In lavorazione';
			case 'red':
				return 'Non conforme';
			case 'yellow':
				return 'Incompleta';
			case 'green':
				return 'Conforme';
			case 'green_white':
				return 'Conforme - da validare';
			case 'green_white_settled':
				return 'Conforme - validato';
			default:
				return 'Non conforme';
		}
	};

	// N.D.R. use the subsequent function if you want to retrieve only the available color options for a specific field

	// const getColorOptionsByField = (fieldName) => {
	// 	return resumeInvoicesRes && resumeInvoicesRes.data
	// 		? resumeInvoicesRes.data.reduce((acc, value) => {
	// 				if (!value[fieldName] || !value[fieldName].checkliststatus) {
	// 					if (acc.map((el) => el.value).includes('white')) return acc;
	// 					acc.push({
	// 						value: 'white',
	// 						label: getMessageByStoplightColor('white'),
	// 					});
	// 					return acc;
	// 				}
	// 				if (acc.map((el) => el.value).includes(value[fieldName].checkliststatus.color)) return acc;

	// 				acc.push({
	// 					value: value[fieldName].checkliststatus.color,
	// 					label: getMessageByStoplightColor(value[fieldName].checkliststatus.color),
	// 				});

	// 				return acc;
	// 			}, [])
	// 		: [];
	// };

	// N.D.R. use the subsequent variable if you want to retrieve all the possible color options
	const options = [
		{
			value: 'white',
			label: getMessageByStoplightColor('white'),
		},
		{
			value: 'gray',
			label: getMessageByStoplightColor('gray'),
		},
		{
			value: 'red',
			label: getMessageByStoplightColor('red'),
		},
		{
			value: 'yellow',
			label: getMessageByStoplightColor('yellow'),
		},
		{
			value: 'green',
			label: getMessageByStoplightColor('green'),
		},
		{
			value: 'green_white',
			label: getMessageByStoplightColor('green_white'),
		},
		{
			value: 'green_white_settled',
			label: getMessageByStoplightColor('green_white_settled'),
		},
	];

	const statusOption = {
		name: 'status',
		label: 'Stato',
		options,
		type: 'static',
		needsEntityType: true,
	};

	const hasDocumentsOption = {
		name: 'has_document',
		label: 'Contiene documenti',
		switchLabelPrefix: 'Filtra soltanto',
		switchLabelSuffix: 'per documenti e allegati',
		type: 'boolean',
		options: [
			{
				value: '1',
				label: 'Presenti',
			},
			{
				value: '0',
				label: 'Assenti',
			},
			{
				value: 'none',
				label: 'Nessun filtro',
			},
		],
	};

	const hasAvvisoOption = {
		name: 'has_document',
		extraQueryParams: [
			{
				name: 'document_codes',
				value: 'PA_AVVISO',
			},
		],
		label: 'Avviso di pagamento',
		switchLabelPrefix: 'Filtra per',
		switchLabelSuffix: 'con avviso',
		type: 'boolean-extra',
		options: [
			{
				value: '1',
				label: 'Presente',
			},
			{
				value: '0',
				label: 'Assente',
			},
			{
				value: 'none',
				label: 'Nessun filtro',
			},
		],
	};

	const hasGiustificativoOption = {
		name: 'has_document',
		extraQueryParams: [
			{
				name: 'document_codes',
				value: 'PA_GIUSTIFICATIVO',
			},
		],
		label: 'Giustificativo di pagamento',
		switchLabelPrefix: 'Filtra per',
		switchLabelSuffix: 'con giustificativo',
		type: 'boolean-extra',
		options: [
			{
				value: '1',
				label: 'Presente',
			},
			{
				value: '0',
				label: 'Assente',
			},
			{
				value: 'none',
				label: 'Nessun filtro',
			},
		],
	};

	const reportableOptions = [
		{
			value: '1',
			label: 'Eleggibili',
		},
		{
			value: '0',
			label: 'Non eleggibili',
		},
		{
			value: 'none',
			label: 'Nessun filtro',
		},
	];

	const reportableOption = {
		name: 'reportable',
		label: 'Catene documentali',
		type: 'boolean',
		options: reportableOptions,
	};

	const controlOption = {
		name: 'control',
		label: 'Domanda contenuta',
		type: 'control',
		needsEntityType: true,
	};
	const userOptions =
		users?.map((user) => ({
			value: `${user.id}`,
			label: `${user.firstName} ${user.lastName}`,
		})) ?? [];

	const filterFields = [
		{
			name: 'ownership',
			label: 'Ownership',
			queryParamName: 'assigned',
			options: [{ value: 'none', label: 'Non assegnate' }, ...userOptions],
			searchCheckboxAdvancedFilter: true,
			optionsType: 'dynamic',
		},
		{
			name: 'tender',
			label: 'Procedura',
			// options: getColorOptionsByField('tender'),
			options,
			queryParamName: 'tenders_color',
			entityType: 'tenders',
			needsEntityType: true,
			advancedOptions: [statusOption, controlOption, hasDocumentsOption],
			pluralLabel: 'procedure',
			optionsType: 'static',
		},
		{
			name: 'frameworkContract',
			label: 'Contratto aperto',
			// options: getColorOptionsByField('frameworkcontract'),
			options,
			queryParamName: 'frameworkcontracts_color',
			entityType: 'frameworkcontracts',
			needsEntityType: true,
			advancedOptions: [statusOption, controlOption, hasDocumentsOption],
			pluralLabel: 'contratti aperti',
			optionsType: 'static',
		},
		{
			name: 'contract',
			label: 'Incarico/Attingimento',
			// options: getColorOptionsByField('contract'),
			options,
			queryParamName: 'contracts_color',
			entityType: 'contracts',
			needsEntityType: true,
			advancedOptions: [statusOption, controlOption, hasDocumentsOption],
			pluralLabel: 'incarichi/attingimenti',
			optionsType: 'static',
		},
		{
			name: 'invoice',
			label: 'Fattura',

			// options: getColorOptionsByField('invoice'),
			options,
			queryParamName: 'invoices_color',
			entityType: 'invoices',
			needsEntityType: true,
			advancedOptions: [statusOption, controlOption, hasDocumentsOption],
			pluralLabel: 'fatture',
			optionsType: 'static',
		},
		{
			name: 'invoicepayment',
			label: 'Pagamento',
			// options: getColorOptionsByField('payment'),
			options,
			queryParamName: 'invoicepayments_color',
			entityType: 'invoicepayments',
			needsEntityType: true,
			advancedOptions: [
				statusOption,
				controlOption,
				// hasDocumentsOption, hasNoDocumentsOption
				hasAvvisoOption,
				hasGiustificativoOption,
				// hasNoAvvisoOption,
				// hasNoGiustificativoOption,
			],
			pluralLabel: 'pagamenti',
			optionsType: 'static',
		},
		{
			name: 'reportable',
			label: 'Catene documentali',
			queryParamName: 'reportable',
			type: 'boolean',
			options: reportableOptions,
			advancedOptions: [reportableOption],
			booleanLabel: 'Elementi eleggibili',
		},
	];

	const isChecked = queryParams?.replace('[]', '').includes(`assigned=${myUserId}`) || false;

	const isFirstRender = useRef(true);

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			return;
		}
	}, []);

	// console.log('isPendingResumeInvoices', isPendingResumeInvoices);
	// console.log('isFetchingResumeInvoices', isFetchingResumeInvoices);
	// console.log('isLoadingResumeInvoices', isLoadingResumeInvoices);
	// console.log('isRefetchingResumeInvoices', isRefetchingResumeInvoices);
	return (
		<>
			<Row className="my-5">
				<Col>
					<span className="d-block mb-1" style={{ fontWeight: '700' }}>
						Fai click sugli elementi nelle celle per eseguire le azioni di controllo.
					</span>
					<span className="d-block">Potrai consultare la documentazione allegata e rispondere alle checklist.</span>
				</Col>
				<Col className="col-auto align-self-center">
					<ButtonToolbar className="justify-content-end align-items-center">
						<Form.Check
							className="me-3 new custom-switch"
							inline
							reverse
							label={'assegnate a me'}
							name="group1"
							type="switch"
							value="showMonths"
							// onClick={handleAssignedToMe}
							onChange={handleAssignedToMe}
							//onClick={(e) => filterByUser(e.target.checked, myUser.id)}
							disabled={!isActiveSampling}
							checked={isChecked}
						/>
						<CustomFilter
							filterFields={filterFields}
							// queryParams={queryParams}
							setQueryParams={setQueryParams}
							activeFilters={activeFilters}
							setActiveFilters={setActiveFilters}
							pageName="Controllo"
							projectName={project.name}
						/>
						{/* <RefreshButton /> */}
						<div className="ms-3">
							<CustomSearch
								ref={searchRef}
								isLoading={isPendingResumeInvoices}
								activeFilters={activeFilters}
								setActiveFilters={setActiveFilters}
								setQueryParams={setQueryParams}
							/>
						</div>

						{/* <CustomQuickFilterBox
							tableRef={externalSuppliesRef}
							dataMeta={externalSuppliesMeta}
							setData={setExternalSupplies}
							dataLength={externalSupplies?.length}
							isFirstResearch={isFirstResearch1}
							setIsFirstResearch={setIsFirstResearch1}
							refTable="externalSupplies"
							isRefreshing={isPendingResumeInvoices || isFetchingResumeInvoices}
							queryParams={queryParams}
							// setIsRefreshing={setIsLoading}
						/> */}
					</ButtonToolbar>
				</Col>
			</Row>
			<FiltersToDisplay
				queryParams={queryParams}
				setQueryParams={setQueryParams}
				filterFields={filterFields}
				isCompleteList={isCompleteList}
				myUser={myUser}
				activeFilters={activeFilters}
				setActiveFilters={setActiveFilters}
				searchRef={searchRef}
			/>

			<Row>
				{/* {console.log('isPendingResumeInvoices', isPendingResumeInvoices)}
				{console.log('isFetchingResumeInvoices', isFetchingResumeInvoices)} */}
				{!isFirstRender.current ? (
					<Col className="col-12 col-xxl-9 pe-0" id="grid-wrapper">
						<div className="ag-theme-alpine new list-table mb-4" style={{ height: '800px' }}>
							<AgGridReact
								loadingOverlayComponent={() => <Loading />}
								ref={externalSuppliesRef}
								columnDefs={columnDefsExternalSupplies}
								rowData={externalSupplies}
								defaultColDef={defaultColDef}
								tooltipShowDelay={0}
								tooltipHideDelay={2000}
								tooltipMouseTrack={true}
								//onGridReady={(params) => setGridApi(params.api)}
								onGridReady={(params) => {
									params.columnApi.autoSizeAllColumns();
								}}
								//onFilterChanged={onFilterChanged}
								headerHeight={80}
								rowHeight={80}
								ariaDescription="ag-grid-table"
								suppressCellFocus={true}
								rowSelection="single"
								autoSizeStrategy={{ type: 'fitCellContents' }}
								localeText={localeText}
								context={{
									openRowId,
									setOpenRowId,
								}}
							/>
							{externalSuppliesMeta && Object.keys(externalSuppliesMeta).length > 0 && (
								<CustomPaginationMui
									dataMeta={externalSuppliesMeta}
									setData={setExternalSupplies}
									setDataMeta={setExternalSuppliesMeta}
									refTable="externalSupplies"
									// setIsFirstResearch={setIsFirstResearch1}
								/>
							)}
						</div>
					</Col>
				) : (
					<div className="text-center my-4">
						<Spinner animation="border" role="status">
							<span style={{ visibility: 'hidden' }}>Caricamento...</span>
						</Spinner>
					</div>
				)}
			</Row>

			{project && renderCorrectModal(apiToCall)}
		</>
	);
};
export default ExternalSupplies;
